
import { Component, Vue } from "vue-property-decorator";
import IngenieriaItem from "@/components/Ingenieria/IngenieriaItem.vue";

@Component({
  components: {
    IngenieriaItem
  }
})
export default class IngenieriaDeportivas extends Vue {
  
  frame = "LINEA_2_5_ingenieria_depor.png";
  
  // texto = `<span class="texto-rojo">[ver fotos]</span>`;
  texto = "";
}
